module.exports = __webpack_public_path__ + "img/focus.521b09a4.png";